<ng-container>
  <div class="wrapper__form">
    <div
      class="d-flex flex-xl-row align-items-center mb-4 justify-content-between">
      <h2 class="wrapper__form__title h4-tipografia-govco mb-0">
        {{ proconText['tramite-sic-procon']['pretenciones'] }}
      </h2>

    </div>
    <span
      class="form-label text3-tipografia-govco text-danger">
      {{ proconText['tramite-sic-procon']['texto-pretencion'] }}
    </span>
    <br/>
    <div class="row pt-3 container-button-modal"
         *ngIf="tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_EG'">

      <b *ngIf="principal && mostar">{{ proconText['tramite-sic-procon']['pretencion-principal'] }}</b>
      <b *ngIf="!principal && mostar">{{ proconText['tramite-sic-procon']['pretension-subsidiaria'] }}</b>

      <button
        type="button"
        class="btn-govco fill-btn-govco ms-2"
        style="width: 280px; height: 42px"
        *ngIf="!mostar && listaPretensionesPrincipales.length === 0"
        (click)="agregar(true)"
        [attr.aria-label]="proconText['tramite-sic-procon']['agregar-pretension-principal']">
        {{ proconText['tramite-sic-procon']['agregar-pretension-principal'] }}
      </button>

      <form [formGroup]="formPretension" *ngIf="mostar">
        <div
          class="radio-seleccion-govco ms-2 mt-4"
          *ngFor="let tipo of listaTipoPretension_pr_eg">
          <input
            type="radio"
            [id]="'radio-' + tipo.Id"
            [value]="tipo.Codigo"
            formControlName="tipoPretension"/>
          <label [for]="'radio-' + tipo.Id">{{ tipo.Valor }}</label>
        </div>

        <br/>
        <div
          *ngIf="
            formPretension.value?.tipoPretension === 'TP_QRB' ||
            formPretension.value?.tipoPretension === 'TP_COPL'
          ">
          <label class="form-label text3-tipografia-govco" for="detalle1">
            {{ proconText['tramite-sic-procon']['complementar-informacion'] }}
            <span class="text-danger">*</span></label
          >
          <textarea
            id="detalle1"
            class="form-control"
            rows="3"
            formControlName="otraPretension"
            placeholder="Complementar información"
            [ngClass]="{
              'is-invalid':
                formPretension.get('otraPretension')?.invalid &&
                formPretension.get('otraPretension')?.touched,
            }"></textarea>
          <div
            *ngIf="formPretension.get('otraPretension')?.errors?.['required']"
            class="invalid-feedback">
            {{ proconText['tramite-sic-procon']['campo-required'] }}
          </div>
          <div
            *ngIf="formPretension.get('otraPretension')?.errors?.['minlength']"
            class="invalid-feedback">
            {{ proconText['tramite-sic-procon']['otra-pretencion-minlength'] }}
          </div>
          <div
            *ngIf="formPretension.get('otraPretension')?.errors?.['maxlength']"
            class="invalid-feedback">
            {{ proconText['tramite-sic-procon']['otra-pretencion-maxlength'] }}
          </div>
          <div
            *ngIf="formPretension.get('otraPretension')?.errors?.['pattern']"
            class="invalid-feedback">
            {{ comunText['pattern-espacios'] }}
          </div>
        </div>
      </form>

      <div class="col-12 d-flex justify-content-start my-3" *ngIf="mostar">
        <button
          type="submit"
          class="btn-govco fill-before-btn-govco"
          style="width: 165px; height: 42px"
          (click)="cancelar()"
          [attr.aria-label]="proconText['cancelar']">
          {{ proconText['cancelar'] }}
        </button>

        <button
          type="button"
          class="btn-govco fill-btn-govco ms-2"
          style="width: 180px; height: 42px"
          [disabled]="!habilitarBotonAgregar()"
          (click)="agregarPretension()"
          [attr.aria-label]="comunText['agregar']">
          {{ comunText['agregar'] }}
        </button>
      </div>

      <div class="col-12 d-flex justify-content-start my-3">
        <button
          *ngIf="listaPretensionesPrincipales.length > 0"
          type="submit"
          style="width: 280px; height: 42px"
          class="btn-govco fill-btn-govco ms-2"
          (click)="modificarPretension()"
          [attr.aria-label]="proconText['tramite-sic-procon']['modificar-pretension']">
          {{ proconText['tramite-sic-procon']['modificar-pretension'] }}
        </button>
        <button
          *ngIf="listaPretensionesPrincipales.length > 0"
          type="submit"
          style="width: 280px; height: 42px"
          class="btn-govco fill-btn-danger-govco ms-2"
          (click)="borrarPretension()"
          [attr.aria-label]="proconText['tramite-sic-procon']['eliminar-pretension']">
          {{ proconText['tramite-sic-procon']['eliminar-pretension'] }}
        </button>
      </div>

      <br/>
      <p *ngIf="listaPretensionesPrincipales.length > 0"
          style="margin: 0">
        {{ proconText['tramite-sic-procon']['pretensiones-principal'] }}</p>
      <app-table
        title="Pretensiones Principales"
        [estiloEncabezado]="'height: auto !important;'"
        *ngIf="listaPretensionesPrincipales.length > 0"
        id="tbllistaPretensiones"
        [datos]="datosTablaPretensiones(true)"
        [columnas]="columnsPretensiones"
        [paginacion]="false"/>

      <button
        type="button"
        class="btn-govco fill-btn-govco ms-2 mt-5"
        style="width: 280px; height: 42px" *ngIf="!mostar && mostarPretencionSubsidiaria()"
        (click)="agregar(false)"
        [attr.aria-label]="proconText['tramite-sic-procon']['agregar-pretension-subsidiaria']">
        {{ proconText['tramite-sic-procon']['agregar-pretension-subsidiaria'] }}
      </button>

      <p *ngIf="datosTablaPretensiones(false).length > 0"
         style="margin: 0" class="mt-3">
        {{ proconText['tramite-sic-procon']['pretensiones-subsidiaria'] }}</p>
      <app-table
        title="Pretensiones Principales"
        [estiloEncabezado]="'height: auto !important;'"
        *ngIf="datosTablaPretensiones(false).length > 0"
        id="tbllistaPretensionesSubsidiarias"
        [datos]="datosTablaPretensiones(false)"
        [columnas]="columnsPretensiones"
        [paginacion]="false"/>

    </div>

    <div class="row pt-3 container-button-modal"
         *ngIf="tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_PC'">

      <b>{{ proconText['tramite-sic-procon']['pretencion-principal'] }}</b>

      <form [formGroup]="formPretension">
        <div
          class="checkbox-seleccion-govco ms-2 mt-4"
          *ngFor="let tipo of listaTipoPretension_pr_pc">

          <input
            type="checkbox"
            [id]="'checkbox-' + tipo.Id"
            [value]="tipo.Codigo"
            (change)="cambioPretension($event, tipo)"
            [checked]="estaSeleccionado(tipo.Codigo)"/>
          <label [for]="'checkbox-' + tipo.Id">{{ tipo.Valor }}
            <span *ngIf="tipo.Codigo === 'TP_DVNPP' || tipo.Codigo === 'TP_DAASC'" class="text-danger">*</span></label>

          <!-- Mensaje de error para el checkbox obligatorio -->
          <div *ngIf="(tipo.Codigo === 'TP_DAASC')
          && formPretension.get('TP_requerida')?.invalid && formPretension.get('TP_requerida')?.touched"
               class="text-danger">
            {{ proconText['tramite-sic-procon']['campo-required'] }}
          </div>

          <div *ngIf="(tipo.Codigo === 'TP_DVNPP')
          && formPretension.get('TP_requerida')?.invalid && formPretension.get('TP_requerida')?.touched"
               class="text-danger">
            {{ proconText['tramite-sic-procon']['campo-required'] }}
          </div>

          <!-- Textarea solo si el tipo requiere detalle y está seleccionado -->
          <div *ngIf="(tipo.Codigo === 'TP_COPL' || tipo.Codigo === 'TP_DAASC') && estaSeleccionado(tipo.Codigo)">
            <textarea
              [id]="'detalle-' + tipo.Id"
              class="form-control"
              rows="3"
              [formControl]="getControlDetalle(tipo.Codigo)"
              placeholder="Complementar información"
              [ngClass]="{
              'is-invalid':
                getControlDetalle(tipo.Codigo).invalid &&
                (getControlDetalle(tipo.Codigo).touched)
            }"></textarea>
            <div *ngIf="getControlDetalle(tipo.Codigo).invalid && (getControlDetalle(tipo.Codigo).touched)"
                 class="text-danger">
              {{ proconText['tramite-sic-procon']['campo-required'] }}
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="row pt-3 container-button-modal"
         *ngIf="tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_PVDC'">

      <b>{{ proconText['tramite-sic-procon']['pretencion-principal'] }}</b>

      <form [formGroup]="formPretension">
        <div
          class="checkbox-seleccion-govco ms-2 mt-4"
          *ngFor="let tipo of listaTipoPretension_pr_pvdc">

          <input
            type="checkbox"
            [id]="'checkbox-' + tipo.Id"
            [value]="tipo.Codigo"
            (change)="cambioPretension($event, tipo)"
            [checked]="estaSeleccionado(tipo.Codigo)"/>
          <label [for]="'checkbox-' + tipo.Id">{{ tipo.Valor }}
            <span *ngIf="tipo.Codigo === 'TP_RB' || tipo.Codigo === 'TP_COPL'"></span>
          </label>
          <!-- Mensaje de error para el checkbox obligatorio -->
          <div *ngIf="(tipo.Codigo === 'TP_RB')
          && formPretension.get('TP_requerida')?.invalid && formPretension.get('TP_requerida')?.touched"
               class="text-danger">
            {{ proconText['tramite-sic-procon']['campo-required'] }}
          </div>

          <div *ngIf="(tipo.Codigo === 'TP_COPL')
          && formPretension.get('TP_requerida')?.invalid && formPretension.get('TP_requerida')?.touched"
               class="text-danger">
            {{ proconText['tramite-sic-procon']['campo-required'] }}
          </div>
          <!-- Textarea solo si el tipo requiere detalle y está seleccionado -->
          <div *ngIf="(tipo.Codigo === 'TP_COPL' || tipo.Codigo === 'TP_RB') && estaSeleccionado(tipo.Codigo)">
            <textarea
              [id]="'detalle-' + tipo.Id"
              class="form-control"
              rows="3"
              [formControl]="getControlDetalle(tipo.Codigo)"
              placeholder="Complementar información"
              [ngClass]="{
              'is-invalid':
                getControlDetalle(tipo.Codigo).invalid &&
                (getControlDetalle(tipo.Codigo).touched)
            }"></textarea>
            <div *ngIf="getControlDetalle(tipo.Codigo).invalid && (getControlDetalle(tipo.Codigo).touched)"
                 class="text-danger">
              {{ proconText['tramite-sic-procon']['campo-required'] }}
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="row pt-3 container-button-modal"
         *ngIf="tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_PSIB'">

      <b>{{ proconText['tramite-sic-procon']['pretencion-principal'] }}</b>
      <form [formGroup]="formPretension">
        <div
          class="checkbox-seleccion-govco ms-2 mt-4"
          *ngFor="let tipo of listaTipoPretension_pr_psib">

          <input
            type="checkbox"
            [id]="'checkbox-' + tipo.Id"
            [value]="tipo.Codigo"
            (change)="cambioPretension($event, tipo)"
            [checked]="estaSeleccionado(tipo.Codigo)"/>
          <label [for]="'checkbox-' + tipo.Id">{{ tipo.Valor }}
            <span *ngIf="tipo.Codigo === 'TP_DRHD'" class="text-danger">*</span></label>

          <!-- Mensaje de error para el checkbox obligatorio -->
          <div
            *ngIf="tipo.Codigo === 'TP_DRHD' && formPretension.get('TP_requerida')?.invalid && formPretension.get('TP_requerida')?.touched"
            class="text-danger">
            {{ proconText['tramite-sic-procon']['campo-required'] }}
          </div>

          <!-- Textarea solo si el tipo requiere detalle y está seleccionado -->
          <div *ngIf="(tipo.Codigo === 'TP_PSI' || tipo.Codigo === 'TP_AA') && estaSeleccionado(tipo.Codigo)">
          <textarea
            [id]="'detalle-' + tipo.Id"
            class="form-control"
            rows="3"
            [formControl]="getControlDetalle(tipo.Codigo)"
            placeholder="Complementar información"
            [ngClass]="{
              'is-invalid':
                getControlDetalle(tipo.Codigo).invalid &&
                (getControlDetalle(tipo.Codigo).touched)
            }"></textarea>
            <div *ngIf="getControlDetalle(tipo.Codigo)?.invalid && (getControlDetalle(tipo.Codigo)?.touched)"
                 class="text-danger">
              {{ proconText['tramite-sic-procon']['campo-required'] }}
            </div>
          </div>

          <!-- Text solo si el tipo requiere detalle y está seleccionado -->
          <div *ngIf="tipo.Codigo === 'TP_PI' && estaSeleccionado(tipo.Codigo)">
            <input
              [id]="'detalle-' + tipo.Id"
              class="form-control"
              [formControl]="getControlDetalle(tipo.Codigo)"
              placeholder="Complementar información"
              [ngClass]="{
            'is-invalid':
              getControlDetalle(tipo.Codigo).invalid &&
              (getControlDetalle(tipo.Codigo).touched)
          }"/>
            <div *ngIf="getControlDetalle(tipo.Codigo)?.invalid && (getControlDetalle(tipo.Codigo)?.touched)"
                 class="text-danger">
              {{ proconText['tramite-sic-procon']['campo-required'] }}
            </div>
          </div>
        </div>

        <div>
          <label class="form-label text3-tipografia-govco" for="juramento1">
            {{ proconText['tramite-sic-procon']['juramento-estimatorio'] }}
          </label>
          <textarea
            id="juramento1"
            class="form-control"
            rows="3"
            formControlName="juramento"
            [placeholder]="proconText['tramite-sic-procon']['juramento-pretenciones']"
            [ngClass]="{
          'is-invalid':
            formPretension.get('juramento')?.invalid &&
            (formPretension.get('juramento')?.touched),
        }"></textarea>
          <div *ngIf="formPretension.get('juramento')?.invalid && (formPretension.get('juramento')?.touched)"
               class="text-danger">
            {{ proconText['tramite-sic-procon']['juramento-minlength'] }}
          </div>
        </div>
      </form>
    </div>

    <div class="row pt-3 container-button-modal"
         *ngIf="tramiteSic?.tipoProteccion?.tipoProteccion?.codigo === 'PR_PIE'">

      <b>{{ proconText['tramite-sic-procon']['pretencion-principal'] }}</b>

      <form [formGroup]="formPretension">
        <div
          class="checkbox-seleccion-govco ms-2 mt-4"
          *ngFor="let tipo of listaTipoPretension_pr_pie">

          <input
            type="checkbox"
            [id]="'checkbox-' + tipo.Id"
            [value]="tipo.Codigo"
            (change)="cambioPretension($event, tipo)"
            [checked]="estaSeleccionado(tipo.Codigo)"/>
          <label [for]="'checkbox-' + tipo.Id">{{ tipo.Valor }}
            <span *ngIf="tipo.Codigo === 'TP_IPSE'" class="text-danger">*</span></label>

          <!-- Mensaje de error para el checkbox obligatorio -->
          <div
            *ngIf="tipo.Codigo === 'TP_IPSE' && formPretension.get('TP_requerida')?.invalid && formPretension.get('TP_requerida')?.touched"
            class="text-danger">
            {{ proconText['tramite-sic-procon']['campo-required'] }}
          </div>

          <!-- Textarea solo si el tipo requiere detalle y está seleccionado -->
          <div *ngIf="(tipo.Codigo === 'TP_AD' || tipo.Codigo === 'TP_MCO') && estaSeleccionado(tipo.Codigo)">
        <textarea
          [id]="'detalle-' + tipo.Id"
          class="form-control"
          rows="3"
          [formControl]="getControlDetalle(tipo.Codigo)"
          placeholder="Complementar información"
          [ngClass]="{
            'is-invalid':
              getControlDetalle(tipo.Codigo).invalid &&
              (getControlDetalle(tipo.Codigo).touched)
          }"></textarea>
            <div *ngIf="getControlDetalle(tipo.Codigo)?.invalid && (getControlDetalle(tipo.Codigo)?.touched)"
                 class="text-danger">
              {{ proconText['tramite-sic-procon']['campo-required'] }}
            </div>
          </div>

          <!-- Text solo si el tipo requiere detalle y está seleccionado -->
          <div *ngIf="tipo.Codigo === 'TP_PI' && estaSeleccionado(tipo.Codigo)">
            <input
              [id]="'detalle-' + tipo.Id"
              class="form-control"
              [formControl]="getControlDetalle(tipo.Codigo)"
              placeholder="Complementar información"
              [ngClass]="{
            'is-invalid':
              getControlDetalle(tipo.Codigo).invalid &&
              (getControlDetalle(tipo.Codigo).touched)
          }"/>
            <div *ngIf="getControlDetalle(tipo.Codigo)?.invalid && (getControlDetalle(tipo.Codigo)?.touched)"
                 class="text-danger">
              {{ proconText['tramite-sic-procon']['campo-required'] }}
            </div>
          </div>
        </div>

        <div>
          <label class="form-label text3-tipografia-govco" for="juramento">
            {{ proconText['tramite-sic-procon']['juramento-estimatorio'] }}
          </label>
          <textarea
            id="juramento"
            class="form-control"
            rows="3"
            formControlName="juramento"
            [placeholder]="proconText['tramite-sic-procon']['juramento-pretenciones']"
            [ngClass]="{
          'is-invalid':
            formPretension.get('juramento')?.invalid &&
            (formPretension.get('juramento')?.touched),
        }"></textarea>
          <div *ngIf="formPretension.get('juramento')?.invalid && (formPretension.get('juramento')?.touched)"
               class="text-danger">
            {{ proconText['tramite-sic-procon']['juramento-minlength'] }}
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="col-12 col-md-12 py-3 d-flex justify-content-end">
    <div class="d-flex flex-column flex-md-row gap-2">
      <button
        type="submit"
        class="btn-govco fill-before-btn-govco w-auto"
        (click)="anterior()"
        onClick="nextItemAdvanceLineIHorizonalBack(event)"
        [attr.aria-label]="proconText['botones-envio']['atras']">
        {{ proconText['botones-envio']['atras'] }}
      </button>

      <button
        type="button"
        class="btn-govco fill-btn-govco w-auto"
        (click)="pasarAFundamentosDerecho($event, true)"
        [attr.aria-label]="proconText['botones-envio']['guardar-sin-enviar']">
        {{ proconText['botones-envio']['guardar-sin-enviar'] }}
      </button>

      <button
        type="submit"
        class="btn-govco fill-next-btn-govco w-auto"
        (click)="pasarAFundamentosDerecho($event, false)"
        [attr.aria-label]="proconText['siguiente']">
        {{ proconText['siguiente'] }}
      </button>
    </div>
    <!--[disabled]="formPretension.invalid"-->
  </div>
</ng-container>
